import { Organization } from '@teammood/shared/util/core';
import { OrganizationService } from './organization.service';
import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { LoggerService } from "@teammood/shared/util/logger";
import { catchError, EMPTY, filter, from, mergeMap, Subject, takeUntil, tap } from "rxjs";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'organization',
    templateUrl: 'organization.component.html',
    providers: [
        OrganizationService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrganizationComponent implements OnInit, OnDestroy {

    orgId: string;
    organization: Organization & { activeTeamsCount?: number };
    max_capacity_reached: boolean;

    private _destroy$ = new Subject<void>();

    constructor(private logger: LoggerService, private organizationService: OrganizationService, private route: ActivatedRoute) {
    }

    ngOnInit() {

        this.route.params
            .pipe(
                filter(params => !!params['id']),
                mergeMap(params => {
                    this.orgId = params['id'];
                    return from(this.init(this.orgId));
                }),
                takeUntil(this._destroy$)
            ).subscribe();
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    
    private async init(orgId: string){
        
        this.organizationService.get(orgId).pipe(
            tap(organization => {
                this.organization = organization;
                this.organization.activeTeamsCount = organization.teams.filter(t => {return t.active}).length;
                this.max_capacity_reached = organization.maxUsers ? organization.maxUsers < organization.activeMembersCount : false;
            }),
            catchError(error => {
                this.logger.error(error);
                return EMPTY;
            }),
            takeUntil(this._destroy$)
        ).subscribe();
    }

}